export default "__VITE_ASSET__CLT9ZJYh__"